(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('offlinePaymentMethod', offlinePaymentMethod);

    function offlinePaymentMethod(lodash) {
        return {
            retrict: 'E',
            scope: {
                options: '=?',
            },
            require: 'ngModel',
            templateUrl: 'common/app/components/billing/offline-payment-methods',
            link: function (scope, iElement, iAttrs, ngModelCtrl) {

                ngModelCtrl.$formatters.push(function(modelValue) {

                    if (!lodash.get(modelValue, 'payment_method', false)) {
                        modelValue.payment_method = getFirstTypeValue();
                    }

                    if (!lodash.get(modelValue, 'formDetails', false)) {
                        modelValue.form_details = initFormDetail();
                    }

                    return modelValue;
                });

                ngModelCtrl.$render = function() {
                    scope.ppModel = ngModelCtrl.$viewValue;
                };

                function setModel() {
                    ngModelCtrl.$setViewValue(scope.ppModel);
                }

                function getFirstTypeValue() {
                    if (lodash.has(scope.options, 'types')
                        && scope.options.types instanceof Array
                        && scope.options.types.length > 0) {
                        return scope.options.types[0].value;
                    }
                    return false;
                }

                function initFormDetail() {

                    if (getFirstTypeValue()) {
                        return scope.options.types.reduce(function(result, type) {
                            result[type.value] = {};
                            return result;
                        }, {});
                    }
                    return {};
                }
            },
        };
    }
})();